import React, { useState } from "react";
import { Header, TopBar } from "../components/Header";
import { Footer } from "../components/Footer";
import { ServiceCard } from "../components/Card";
import { HeroSlider } from "../components/Slider";
import { EquipementContainer, SoftwareContainer } from "../components/Container";
import { MaintenanceRequestModal } from "../components/Modal";
import homeData from "../app/data/homeData";
import { useLocation } from "react-router";


export function Home() 
{
  const [showModal, setShowModal] = useState(false);
  const [curMaintenance, setCurMaintenance] = useState('');

  const location = useLocation();
  const message = location.state?.message;
  
  const openMaintenanceModal = (item) => {
    setShowModal(true);
    setCurMaintenance( item );
  };


  return(

    <div className='container-fluid' >
   
      <div className='row'>
        {message && (
        <div className="alert alert-danger mb-0">
          {message}
        </div>
        )}
      </div>
      <div className='row'> <TopBar /> </div>
      <div className='row sticky-top'> <Header page={1} /> </div>

      {/*_____________ Hero section _______________*/}
      <section className='row'>
        <div className='col-lg-12 bg-light-gray border-bottom'>
           <HeroSlider />
        </div>
      </section>

      {/*______________ Servive section ________________*/}
      <section className='row d-flex justify-content-center'>
        <div className='col-12 px-4 bg-light-gray border-bottom pb-5'>
          <div className="service-features-section px-4 py-3 bg-green border-top border-bottom mb-4">
            <div className="row bg-light-gray p-4">
              { homeData.services.map((service, index) => (
                <ServiceCard key={index} icon={service.icon} title={service.title} description={service.description}/>
              ))}
            </div>
          </div>
       </div>
      </section>

      {/*______________ New Arrivals section ________________*/}
      <section className="row justify-content-center pt-5 pb-2">
        <div className="col-lg-10">
            <EquipementContainer />
        </div>
      </section>
        
      {/*______________ Maintenance section ________________*/}

      <section className='row justify-content-center pb-5'>
        <div className='col-lg-10'>
          <div className="row g-4">
             { homeData.categories.map((cat) => (
              <div key={cat.id} className={cat.size}>
                <div className="category-card p-4 d-flex flex-column flex-md-row align-items-center justify-content-between" style={{ backgroundColor: cat.bg }}>
                  <div className="d-flex flex-column text-content">
                    <h3 className={ cat.detail ? 'category-title' : 'text-light h3' } >{cat.title}</h3>
                    <span className={ cat.detail ? 'text-secondary' : 'text-light' }>{cat.desc}</span>
                    <div> 
                      <button 
                        className={`btn rounded-0 mt-3 ${ cat.detail ? 'btn-outline-dark' : 'btn-outline-light'}`}
                        onClick={() => openMaintenanceModal( cat.category ) }  >
                        Contacter <i className="bi bi-chevron-right" ></i>
                      </button> 
                    </div>  
                  </div>
                  <div className={ cat.detail ? 'image-wrapper' : 'bg-light p-4 rounded-circle' }  >
                    <img src={cat.img} alt={cat.title} height={140} className="category-img" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> 


      {/*______________ Sofware section ________________*/}
      <section className="row justify-content-center pb-5 pt-4">
        <div className="col-lg-10">
            <SoftwareContainer />
        </div>
      </section>

      {/*______________ Features section ________________*/}

      <div className="row py-5 justify-content-center bg-light border-top">
        <div className="col-md-11 py-5">
          <div className="row g-4 justify-content-center">
            <div className="d-flex flex-column align-items-center mb-5">
              <h2 className="text-secondary mb-3"> Tout pour vos équipements et logiciels </h2>
              <span className="p-1 bg-green" style={{ width: '10%' }} ></span>
            </div>
          </div>
          <div className="row g-4">
            { homeData.bottomData.map((cat) => (
              <div className="col-sm-6 col-lg-4" key={cat.id}>
                <div className="border rounded-3 d-flex flex-column p-4">
                  <i className="bi bi-gear display-6 lead text-secondary"> </i>
                  <div className="card-body pt-2">
                      <h5 className="text-secondary"> { cat.title } </h5>
                      <p className="text-secondary"> { cat.desc } </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/*_____________ Footer _______________*/}

      <div className='row'>
        <Footer />
      </div>

      {/* Modal de Demande de Maintenance */}
      <MaintenanceRequestModal show={showModal} onHide={() => setShowModal(false)}  mtype={ curMaintenance } />  
    </div>
  )
}

